import { ApiUtility } from "../../Utilities/ApiUtility.axios";

export enum JournalGetType {
  Basic,
  WithOtherLists,
}

class JournalService {
  private route = "/v1/api/Journal";

  getJournalData = (
    clientId: string,
    id?: string,
    getType?: JournalGetType.WithOtherLists
  ) => {
    return ApiUtility.get(
      `${this.route}/${clientId}/Get?${id ? "id=" + id : ""}`,
      {
        getType,
      }
    );
  };

  postJournal = (clientId: string, param: any, id?: string) => {
    return ApiUtility.postForm(
      `${this.route}/${clientId}${id ? "/" + id : ""}`,
      param
    );
  };

  getJournalList = (
    clientId: string,
    start: number,
    length: number,
    search?: string,
    fromDate?: string,
    toDate?: string,
    status?: string,
    sortCol?: string,
    sortDir?: string
  ) => {
    return ApiUtility.getResult(`${this.route}/${clientId}`, {
      search,
      start,
      length,
      fromDate,
      toDate,
      status,
      sortCol,
      sortDir,
    });
  };

  deleteJournal = (clientId: string, id: string, reactivate: boolean) =>
    ApiUtility.get(
      `${this.route}/${clientId}/${id}/Delete?reactivate=${reactivate}`
    );

  getOpeningBalance = (clientId: string) =>
    ApiUtility.get(`${this.route}/${clientId}/Opening`);

  saveOpeningBalance = (clientId: string, date: string, params: any) =>
    ApiUtility.post(
      `${this.route}/${clientId}/SaveOpening?date=${date}`,
      params
    );
}

export default new JournalService();
